<template>
  <el-page-header @back="back" icon="ArrowLeft" class="header">
    <template #content>
      <span class="title"> {{ $route.meta.title }} </span>
    </template>
    <template #extra>
      <p @click="toggleNav" class="menu"><i class="element-icons el-icon-shejimulu"></i></p>
    </template>
  </el-page-header>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const store = useStore();
const router = useRouter();
const toggleNav = ()=>{
  store.commit('SET_TOGGLENAV', !store.state.toggleNav)
}

router.afterEach(()=>{
  store.commit('SET_TOGGLENAV', false)
})

const back = ()=>{
  window.history.go(-1)
}
</script>

<style lang="less" scoped>
.header {
  height: @headMobileHeight;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  background: url(@/assets/images/headerbg.png) no-repeat;
  background-size: 100% 100%;
  color: #fff;
  z-index: @headZindex;
  .title {
    color: #fff;
  }
}
:deep .el-page-header__header {
  width: 100%;
  height: 100%;
}
:deep .el-divider {
  display: none;
}
:deep .el-page-header__left {
  flex-grow: 1;
  margin-right: 0;
}
:deep .el-page-header__content {
  flex-grow: 1;
  text-align: center;
  padding: 0 10px;
}
:deep .el-page-header__icon {
  margin-right: 2px;
}
.menu {
  padding: 10px 0;
}
</style>

